export const privacyPolicyDe =
  "<div>\n" +
  "      <h1>Datenschutzrichtlinie</h1>\n" +
  '      <span class="version">Version 0</span>\n' +
  "\n" +
  "      <p>\n" +
  "        Dawn Health ist der Meinung, dass es sehr wichtig ist, Deine Daten zu schützen. \n" +
  "        Bitte ließ dieses Dokument sorgfältig, da es wichtige Informationen über die \n" +
  "        Verwendung Deiner Daten enthält.\n" +
  "      </p>\n" +
  "      <p>\n" +
  "        Dawn Health ist ein Unternehmen, das nach dänischem Recht gegründet wurde. \n" +
  "        Als für die Datenverarbeitung Verantwortlicher ist Dawn Health für die \n" +
  "        Verarbeitung Deiner Daten zuständig. \n" +
  "        Die entsprechenden Kontaktdaten findest Du unten:\n" +
  "      </p>\n" +
  "\n" +
  '      <p class="indent">\n' +
  "        Dawn Health A/S<br />\n" +
  "        CVR-nr: 37683264<br />\n" +
  "        Sundkaj 153<br />\n" +
  "        2150 Copenhagen<br />\n" +
  "        Denmark<br />\n" +
  '        <a href="mailto:support@nelia-rgd.com">support@nelia-rgd.com</a>\n' +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        In dieser Datenschutzrichtlinie wird erläutert, warum und zu welchem Zweck Dawn Health \n" +
  "        Deine personenbezogenen Daten erhebt und verarbeitet, ob es weitere Empfänger Deiner \n" +
  "        personenbezogenen Daten gibt, ob Deine Daten in ein anderes Land übermittelt \n" +
  "        werden sollen und welche Rechte Du in Bezug auf die Erhebung, \n" +
  "        Verarbeitung und Speicherung Deiner personenbezogenen \n" +
  "        Daten durch Dawn Health hast.\n" +
  "      </p>\n" +
  "      <p>\n" +
  "        Deine Privatsphäre ist für Dawn Health wichtig. \n" +
  "        Dawn Health hält sich bei der Verarbeitung Deiner Daten an die einschlägigen Datenschutzgesetze, \n" +
  "        einschließlich der Datenschutz-Grundverordnung der Europäischen Union (im Folgenden „DSGVO“), \n" +
  "        unterstützt den Schutz Deiner Privatsphäre und respektiert Deine Entscheidungen \n" +
  "        zum Schutz Deiner Privatsphäre. \n" +
  "        Wenn Du Dawn Health personenbezogene Daten zur Verfügung stellst, \n" +
  "        werden diese Daten in Übereinstimmung mit dieser Richtlinie verarbeitet.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Verwendung Deiner Daten</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health verwendet Deine Daten, um Dir den Zugang zur App und ihren Inhalten\n" +
  "        zu ermöglichen. Diese Verwendung Deiner Daten beruht \n" +
  "        auf der notwendigen Erfüllung eines Vertrags \n" +
  "        (Artikel 6 Absatz 1 Buchstabe b DSGVO) oder auf \n" +
  "        Deiner Einwilligung (Artikel 6 Absatz 1 Buchstabe a DSGVO).\n" +
  "      </p>\n" +
  "      <p>\n" +
  "        Ekiva RGD ist eine App, die Patienten, die mit Paroxysmaler \n" +
  "        Nächtlicher Hämoglobinurie („RGD“) leben, bei datengestützten \n" +
  "        Gesprächen mit ihrem medizinischen Fachpersonal unterstützen soll. \n" +
  "        Die App kann als Tagebuch zum Sammeln und Aufzeichnen von Informationen über \n" +
  "        die individuellen Symptome und die Lebensqualität verwendet werden. \n" +
  "        Sie verwendet Gesundheitsdaten auf der Grundlage Deiner Einwilligung \n" +
  "        (Artikel 9 Absatz 2 Buchstabe a DSGVO).\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health beruft sich auch auf sein berechtigtes Interesse, \n" +
  "        die App zu sichern, ihren ordnungsgemäßen Betrieb aufrechtzuerhalten \n" +
  "        und unseren Service zu verbessern und zu personalisieren \n" +
  "        (Artikel 6 Absatz 1 Buchstabe f). Schließlich kann es sein, \n" +
  "        dass Dawn Health Deine Daten verarbeiten muss, um gesetzlichen \n" +
  "        oder behördlichen Verpflichtungen nachzukommen (Artikel 6 Absatz 1 Buchstabe c DSGVO).\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Über Dich erhobene personenbezogene Daten</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn in dieser Richtlinie der Begriff „personenbezogene Daten“ verwendet wird, \n" +
  "        sind damit Informationen gemeint, die sich auf Dich beziehen und die es \n" +
  "        Dawn Health ermöglichen, Dich zu identifizieren, \n" +
  "        entweder direkt oder in Kombination mit anderen Informationen. \n" +
  "        Zu Deinen personenbezogenen Daten gehören beispielsweise Dein Name, \n" +
  "        Deine Kontaktdaten oder Informationen darüber, wie Du unsere Plattform nutzst \n" +
  "        oder wie Du mit ihr interagierst.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health kann Deine personenbezogenen Daten auf unterschiedliche \n" +
  "        Weise erheben oder erhalten, einschließlich wenn Du sie \n" +
  "        direkt zur Verfügung stellst, z. B. durch direkte Interaktion \n" +
  "        mit der App, durch Ausfüllen einer Umfrage, oder wenn eine \n" +
  "        Überwachung eingesetzt wird.\n" +
  "      </p>\n" +
  "      <p>\n" +
  "        Wenn Du Dich als Benutzer der Anwendung registrieren lässt, werden die folgenden personen-bezogenen Daten erhoben:\n" +
  "      </p>\n" +
  "\n" +
  "      <ul>\n" +
  "        <li>Deine E-Mail Adresse und Dein Passwort</li>\n" +
  "        <li>\n" +
  "          Dein Vorname (falls Du ihn angeben möchten; Du kannst auch einen Aliasnamen verwenden)\n" +
  "        </li>\n" +
  "        <li>Dein Geburtsdatum</li>\n" +
  "        <li>Dein Geschlecht (falls Du es angeben möchtest)</li>\n" +
  "      </ul>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health bittet Dich um Deine Einwilligung, \n" +
  "        die folgenden Informationen im Zusammenhang \n" +
  "        mit Deiner Nutzung der App zu erheben:\n" +
  "      </p>\n" +
  "\n" +
  "      <ul>\n" +
  "        <li>\n" +
  "          Gesundheitsdaten (z. B. Erkrankungen, Symptome, Diagnose, \n" +
  "          Behandlungskategorie, Konsultationsdaten, Laborergebnisse)\n" +
  "        </li>\n" +
  "\n" +
  "        <li>Informationen über die Auswirkungen auf Deine Lebensqualität</li>\n" +
  "        <li>\n" +
  "          Deine Antworten auf optionale Umfragen (die auf aggregierter Ebene ausgewertet werden)\n" +
  "        </li>\n" +
  "      </ul>\n" +
  "\n" +
  "      <p>\n" +
  "        Für die sichere und regelmäßige Wartung der App werden die folgenden Informationen verarbeitet:\n" +
  "      </p>\n" +
  "\n" +
  "      <ul>\n" +
  "        <li>\n" +
  "          Nutzungsdaten (z. B. Analyse- und Telemetriedaten, wie \n" +
  "          UserID, Nutzungsdauer in den einzelnen App-Abschnitten, \n" +
  "          Datum der letzten Anmeldung und andere Benutzeraktionen)\n" +
  "        </li>\n" +
  "        <li>\n" +
  "          Gerätedaten (z. B. Geräte-ID, Typ des mobilen Geräts, \n" +
  "          IP-Adresse, Betriebssystem des Geräts)\n" +
  "        </li>\n" +
  "        <li>\n" +
  "          Standortdaten (z. B. Land)\n" +
  "        </li>\n" +
  "      </ul>\n" +
  "\n" +
  "      <p>\n" +
  "        Solche personenbezogenen Daten werden auch in pseudonymisierter \n" +
  "        Form zur Verbesserung und Personalisierung \n" +
  "        unseres Dienstes verarbeitet.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Es können statistische Einblicke oder Nutzungsanalyseberichte erstellt werden, \n" +
  "        um die Leistung und Funktionalität der App zu verfolgen, aber diese enthalten \n" +
  "        nur anonyme Daten, was bedeutet, dass keine dieser Daten verwendet werden können, \n" +
  "        um Dich zu identifizieren.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Für die Verfolgung der mobilen Analyse und die Zuordnung werden die folgenden Informationen verarbeitet:\n" +
  "      </p>\n" +
  "\n" +
  "      <ul>\n" +
  "        <li>Gehashte IP-Adresse</li>\n" +
  "        <li>Werbe-ID oder ähnliche mobile Identifikatoren</li>\n" +
  "        <li>\n" +
  "          Nutzungsdaten (z. B. Installation, App-Version, das erste Öffnen einer \n" +
  "          App auf Deinem Mobilgerät und andere Interaktionen innerhalb einer App)\n" +
  "        </li>\n" +
  "        <li>\n" +
  "          Informationen über Werbung, dieDu gesehen oder angeklickt \n" +
  "          hast und die Du möglicherweise zur App weitergeleitet hast\n" +
  "        </li>\n" +
  "        <li>\n" +
  "          Gerätedaten (z. B. lokale Einstellungen, das Betriebssystem des Geräts)\n" +
  "        </li>\n" +
  "      </ul>\n" +
  "\n" +
  "      <p>\n" +
  "        Die Anwendung kann Felder zur Erfassung von Notizen enthalten. \n" +
  "        Bitte beachte, dass diese Daten nur innerhalb der App auf Deinem \n" +
  "        eigenen Gerät gespeichert werden, was bedeutet, \n" +
  "        dass Dawn Health keinen Zugriff darauf hat.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn Du Deine Kontaktinformationen auf nelia-rgd.com registrieren, \n" +
  "        werden Dein Name und Deine E-Mail-Adresse mit Deiner Einwilligung erhoben, \n" +
  "        um Dir Benachrichtigungen über Produkte und Dienstleistungen \n" +
  "        von Dawn Health zuzusenden.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Darüber hinaus werden Informationen durch Cookies oder ähnliche Technologien erhoben, \n" +
  "        wenn Du die Website besuchst, entweder automatisch oder mit Deiner Einwilligung. \n" +
  "        Unbedingt notwendige Cookies werden ohne Einwilligung des Benutzers aktiviert, \n" +
  "        da sie für das ordnungsgemäße und sichere Funktionieren der Website erforderlich \n" +
  "        sind und daher auf der Grundlage eines berechtigten Interesses verarbeitet werden. \n" +
  "        Alle anderen Cookies und Tracking-Technologien, \n" +
  "        die nicht als unbedingt notwendig eingestuft werden, bedürfen der \n" +
  "        Einwilligung der Website-Besucher. Weitere Informationen über die \n" +
  "        Verwaltung und Verwendung von Cookies findest Du in der Cookie-Richtlinie auf nelia-rgd.com.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Weitergabe Deiner Daten an Dein medizinisches Fachpersonal</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Du kannst sich dafür entscheiden, die Daten innerhalb der Ekiva RGD-App \n" +
  "        mit Deinem medizinischen Fachpersonal oder einem anderen Dritten \n" +
  "        zu teilen. Zu diesem Zweck kannst Du einen Bericht über Deine \n" +
  "        protokollierten Daten exportieren.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health ist für die Verwendung Deiner Daten zu den in dieser \n" +
  "        Datenschutzrichtlinie beschriebenen Zwecken verantwortlich. \n" +
  "        Dein medizinisches Fachpersonal ist für die Verwendung Deiner Daten \n" +
  "        für die medizinische Behandlung und Pflege gesondert verantwortlich. \n" +
  "        Diese Datenschutzrichtlinie gilt nicht für die Verwendung Deiner \n" +
  "        Daten durch Dein medizinisches Fachpersonal. Du kannst Dein medizinisches \n" +
  "        Fachpersonal über die Verwendung Deiner Daten befragen.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Weitergabe Deiner Daten an andere</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health gibt Deine personenbezogenen Daten an Dritte weiter, \n" +
  "        um Dir die Anwendung zur Verfügung zu stellen und um den Betrieb zu sichern. \n" +
  "        Wann immer möglich, werden Deine Daten in pseudonymisierter Form an Dritte weitergegeben.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Deine Daten können von Mitarbeitern von Dawn Health, verbundenen Unternehmen \n" +
  "        und Tochtergesellschaften, unabhängigen Vertretern oder Maklern und Verkäufern, \n" +
  "        Lieferanten und Dienstleistern (z. B. Identitätsanbietern, Cloud-Anbietern und \n" +
  "        Analysetools), Dritten, an die Rechte oder Pflichten abgetreten werden, Beratern \n" +
  "        und externen Anwälten im Zusammenhang mit dem Verkauf oder der Übertragung eines \n" +
  "        Teils des Unternehmens oder seiner Vermögenswerte verarbeitet werden, \n" +
  "        sowie wenn dies gesetzlich vorgeschrieben ist oder um auf \n" +
  "        rechtliche Verfahren zu reagieren.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Diese Personen und Organisationen sind gesetzlich verpflichtet, \n" +
  "        die Vertraulichkeit und Sicherheit Deiner Daten zu schützen.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Bestimmte Geschäftspartner und Lieferanten verarbeiten personenbezogene Daten \n" +
  "        im Auftrag von Dawn Health und dürfen Deine personenbezogenen Daten nur gemäß \n" +
  "        den von Dawn Health erteilten Anweisungen und in Übereinstimmung mit dieser \n" +
  "        Datenschutzrichtlinie, einer unterzeichneten Datenverarbeitungsvereinbarung \n" +
  "        und anderen relevanten Vertraulichkeits- und Sicherheitsmaßnahmen verarbeiten. \n" +
  "        Diese Dritten dürfen Deine personenbezogenen Daten nicht für ihre eigenen \n" +
  "        Zwecke verarbeiten. Soweit Dawn Health Deine personenbezogenen Daten gegenüber \n" +
  "        diesen Dritten, die Deine personenbezogenen Daten für ihre eigenen Zwecke verwenden \n" +
  "        können, offenlegt oder an sie weitergibt, erfolgt eine solche Offenlegung \n" +
  "        oder Weitergabe nur, wenn dies im Einklang mit geltendem Recht steht oder nachdem \n" +
  "        zuvor Deine Einwilligung eingeholt wurde.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Dawn Health kann auch andere Informationen, \n" +
  "        die nicht als personenbezogene Daten gelten, \n" +
  "        an Dritte weitergeben. In diesem Fall werden \n" +
  "        diese Informationen in aggregierter und anonymisierter \n" +
  "        Form weitergegeben, so dass Du oder andere Personen nicht \n" +
  "        identifiziert werden können.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Übermittlung in Länder außerhalb der EU/des EWR</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        In einigen Fällen kann es erforderlich sein, personenbezogene Daten \n" +
  "        in Ländern außerhalb der EU/des EWR zu verarbeiten. Wenn dies der Fall ist, \n" +
  "        werden solche Übermittlungen nur für die oben genannten spezifischen Zwecke \n" +
  "        erfolgen, und es werden geeignete Garantien für solche Übermittlungen vorhanden \n" +
  "        sein, wie z. B. Angemessenheitsbeschlüsse der Kommission der Europäischen Union, \n" +
  "        Standardvertragsklauseln oder andere geeignete Garantien für die Übermittlung gemäß \n" +
  "        Artikel 46 oder 47 der DSGVO.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Aufbewahrungsrichtlinie</h2>\n" +
  "      \n" +
  "      <p>\n" +
  "        Dawn Health speichert Deine Daten so lange wie nötig, um die oben \n" +
  "        beschriebenen Zwecke zu erfüllen und die Aufbewahrungsfrist \n" +
  "        in Übereinstimmung mit den geltenden Gesetzen und internen Richtlinien \n" +
  "        einzuhalten.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn Du verlangst, dass Dein Konto gelöscht wird, oder wenn Du mehr \n" +
  "        als fünf Jahre lang in der App inaktiv warst, werden Deine \n" +
  "        personenbezogenen Daten gelöscht. Es kann bis zu einem Monat \n" +
  "        nach dem Antrag auf Kontolöschung oder nach Ablauf der fünf \n" +
  "        Jahre der Inaktivität dauern, bis die Löschung abgeschlossen ist.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Die über das Website-Formular übermittelten personenbezogenen \n" +
  "        Daten werden nach sechs Monaten gelöscht.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Entnimm die Dauer der Speicherung von Cookies bitte unserer Cookie-Richtlinie.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Deinstallation der App</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Du kannst die Erhebung von Daten ganz einfach beenden, \n" +
  "        indem Du die App deinstallierst. Du kannst die Standard-Deinstallationsprozesse \n" +
  "        verwenden, die möglicherweise als Teil Deines mobilen Geräts oder über den \n" +
  "        mobilen App-Store oder das Netzwerk verfügbar sind. \n" +
  "        Wenn Du die App deinstallierst, werden in Zukunft keine Daten mehr über die App erhoben.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>    \n" +
  "        Bitte beachte, dass Deine personenbezogenen Daten auch nach der Deinstallation \n" +
  "        der App gemäß unserer Aufbewahrungsrichtlinie aufbewahrt werden, wenn Du die \n" +
  "        Löschung Deines Kontos nicht beantragst.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Deine Rechte</h2>\n" +
  "      <p>\n" +
  "        Dawn Health hat alle notwendigen und angemessenen Maßnahmen ergriffen, \n" +
  "        um Deine personenbezogenen Daten zu schützen und Deine Rechte zu wahren, \n" +
  "        die im Folgenden aufgeführt sind. Welche Rechte Ihnen zustehen, hängt vom \n" +
  "        Grund für die Verarbeitung Deiner Daten ab. Wenn Du Deine Rechte wahrnehmen \n" +
  "        möchtest, wende Dich bitte an Dawn Health.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Recht auf Zugang</h2>\n" +
  "      <p>\n" +
  "        Du hast das Recht, Zugang zu den über Dich verarbeiteten personenbezogenen \n" +
  "        Daten zu verlangen. Unter bestimmten Umständen hast Du das Recht, \n" +
  "        personenbezogene Daten in einem strukturierten, gängigen und \n" +
  "        maschinenlesbaren Format zu erhalten, sowie das Recht, dass \n" +
  "        Deine personenbezogenen Daten an einen anderen für die Verarbeitung \n" +
  "        Verantwortlichen übermittelt werden.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Recht auf Berichtigung</h2>\n" +
  "      <p>\n" +
  "        Du hast das Recht, personenbezogene Daten zu berichtigen, die Deiner Meinung \n" +
  "        nach unrichtig sind. Dazu gehört auch die Berichtigung von personenbezogenen Daten, \n" +
  "        die Du für unvollständig hältst.\n" +
  "      </p>\n" +
  "\n" +
  "\n" +
  "      <h2>Recht auf Löschung (Recht auf Vergessenwerden)</h2>\n" +
  "      <p>\n" +
  "        Unter bestimmten Umständen hast Du das Recht, \n" +
  "        Deine personenbezogenen Daten löschen zu lassen. \n" +
  "        Du kannst Dein Konto löschen lassen, indem Du auf der Einstellungsseite, \n" +
  "        die Du durch Klicken auf das Symbol des Einstellungsrades erreichst, \n" +
  "        auf die Option „Mein Konto löschen“ klickst.\n" +
  "      </p>\n" +
  "\n" +
  "\n" +
  "      <h2>Recht auf Widerspruch</h2>\n" +
  "      <p>\n" +
  "        Unter bestimmten Umständen hast Du das Recht, \n" +
  "        der Verarbeitung Deiner personenbezogenen Daten zu widersprechen.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Recht auf Einschränkung</h2>\n" +
  "      <p>\n" +
  "        Unter bestimmten Umständen hast Du das Recht, \n" +
  "        die Verarbeitung Deiner personenbezogenen Daten einzuschränken.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Widerruf der Einwilligung</h2>\n" +
  "      <p>\n" +
  "        Wenn die Verarbeitung von Daten auf Deiner Einwilligung beruht, \n" +
  "        kannst Du Deine Einwilligung jederzeit widerrufen. Bitte beachte jedoch, \n" +
  "        dass dies keine Auswirkungen auf die Verarbeitung Deiner personenbezogenen \n" +
  "        Daten durch Dawn Health hat, bevor Du Deine Einwilligung widerrufen hast.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn Du Deine Einwilligung widerrufen möchtest, \n" +
  "        kannst Du Dein Konto in der App selbst auf der Einstellungsseite löschen.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Bitte beachte, dass Dawn Health Dir die App nicht mehr zur Verfügung stellen kann, \n" +
  "        wenn Du Deine Einwilligung zur Verarbeitung Deiner Gesundheitsdaten widerrufst.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn Du Fragen hast oder eines der oben genannten Rechte ausüben möchtest, \n" +
  "        kannst Du eine E-Mail an die unten stehende Adresse senden. \n" +
  "        Wenn Du Bedenken hast, kannst Du diese an den Datenschutzbeauftragten richten. \n" +
  "        Du hast auch das Recht, Dich bei der zuständigen Datenschutzaufsichtsbehörde zu beschweren.\n" +
  "      </p>\n" +
  "\n" +
  "\n" +
  "      <h2>Kontaktstelle</h2>\n" +
  "\n" +
  "      <h3>Datenschutzbeauftragter</h3>\n" +
  "\n" +
  "      <p>\n" +
  "        Der Datenschutz bei Dawn Health wird vom Datenschutzbeauftragten Dänemarks wahrgenommen. \n" +
  "        Die Kontaktdaten des Datenschutzbeauftragten Dänemarks findest Du unten:\n" +
  "      </p>\n" +
  "\n" +
  '      <p class="indent">\n' +
  "        DPO Danmark ApS<br />\n" +
  "        Højbro Plads 10<br />\n" +
  "        DK-1200 København<br />\n" +
  "        E-mail address:\n" +
  '        <a href="mailto:DPO@dawnhealth.com">DPO@dawnhealth.com</a>\n' +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Wenn Du Fragen oder Bedenken in Bezug auf Deine Rechte als \n" +
  "        betroffene Person hast, kannst Du Dich jederzeit an den \n" +
  "        Datenschutzbeauftragten Dänemarks wenden, der im Namen \n" +
  "        von Dawn Health antworten wird.\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Bitte beachte, dass Du auch das Recht hast, \n" +
  "        Dich an die zuständige Datenschutzbehörde zu wenden, \n" +
  "        um eine Beschwerde einzureichen:\n" +
  "      </p>\n" +
  "\n" +
  '      <p class="indent">\n' +
  "        Danish Datatilsynet<br />\n" +
  "        Borgergade 28, 5<br />\n" +
  "        DK-1300 Copenhagen K<br />\n" +
  "        Phone number: +45 33 19 32 00<br />\n" +
  "        E-Mail address:\n" +
  '        <a href="mailto:dt@datatilsynet.dk">dt@datatilsynet.dk</a><br />\n' +
  "        Website:\n" +
  '        <a href="https://www.datatilsynet.dk">\n' +
  "          www.datatilsynet.dk\n" +
  "        </a><br />\n" +
  "      </p>\n" +
  "\n" +
  "      <p>\n" +
  "        Die Kontaktdaten der nationalen EU-Datenschutzbehörden findest Du auf der\n" +
  '        <a href="https://edpb.europa.eu/about-edpb/about-edpb/members_en">Website des Europäischen Datenschutzausschusses</a>.\n' +
  "      </p>\n" +
  "\n" +
  "      <h2>Änderungen der Datenschutzrichtlinie</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Diese Datenschutzrichtlinie wird regelmäßig aktualisiert, \n" +
  "        wenn dies aufgrund von Änderungen des geltenden Rechts oder \n" +
  "        zur Einhaltung der Transparenzpflicht erforderlich ist. \n" +
  "        Sie wird immer in ihrer neuesten Fassung veröffentlicht. \n" +
  "        Du wirst durch eine Aktualisierung im Rahmen einer allgemeinen \n" +
  "        Anwendungsaktualisierung und auf nelia-rgd.com über alle \n" +
  "        Änderungen der Datenschutzrichtlinie informiert. Wenn die \n" +
  "        Änderungen an dieser Datenschutzrichtlinie als wesentlich erachtet werden, \n" +
  "        wirst Du entsprechend informiert.\n" +
  "      </p>\n" +
  "\n" +
  "      <h2>Impressum</h2>\n" +
  "\n" +
  "      <p>\n" +
  "        Verantwortlich für den Inhalt des Lernportals gemäß \n" +
  "        § 5 TMG: Michael Dunker, c/o Content Fleet GmbH, Kehrwieder 8, \n" +
  "        20457 Hamburg, Deutschland.\n" +
  "      </p>\n" +
  "  </div>";
